// client/src/coms/views/MarketplaceView.js
// The Voxemera Marketplace. Categories:
// - Sticker Packs: published packs from creators, free or paid, searchable by name, creator and keyword. Free
//   packs are added straight away; paid packs show a preview and their price (buying opens when payments are
//   activated; the server refuses paid installs without a purchase). Creators publish from Settings → Stickers.
// - Sound Packs: published soundboard packs (free only for now), from people and from servers. Installing links
//   to the creator's pack. Creators publish from Settings → Soundboard; servers from Server settings → Soundboard.
import React, { useState } from 'react';
import PackBrowser from '../components/PackBrowser';
import SoundPackBrowser from '../components/SoundPackBrowser';

const CATEGORIES = [
  { key: 'stickers', label: 'Sticker Packs', icon: '🏷️', blurb: 'Sticker packs made by the community. Free packs are added to your stickers straight away. Paid packs can be previewed; buying opens when payments are activated.', publish: 'Stickers', publishHint: 'Create a pack, add stickers, then publish it from Settings → Stickers → My packs' },
  { key: 'sounds', label: 'Sound Packs', icon: '🔊', blurb: 'Soundboard packs made by the community and by servers. Preview any sound; installed packs appear in your soundboard and follow their creator’s updates. All sound packs are free.', publish: 'Soundboard', publishHint: 'Create a pack, add sounds, then choose “Marketplace” under Who can use it in Settings → Soundboard' },
];

export default function MarketplaceView({ onOpenSettings }) {
  const [category, setCategory] = useState('stickers');
  const current = CATEGORIES.find((c) => c.key === category) || CATEGORIES[0];
  return (
    <div style={{ height: '100%', overflowY: 'auto', boxSizing: 'border-box', padding: '18px 16px 32px', color: 'var(--vx-text, #fff)' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 12, flexWrap: 'wrap', marginBottom: 14 }}>
          <div style={{ flex: '1 1 260px' }}>
            <h1 style={{ fontSize: 22, fontWeight: 900, margin: 0 }}>Marketplace</h1>
            <div style={{ fontSize: 13, opacity: 0.75, marginTop: 4, lineHeight: 1.45 }}>
              {current.blurb}
            </div>
          </div>
          {typeof onOpenSettings === 'function' ? (
            <button
              type="button"
              className="coms-mini-btn"
              onClick={() => {
                try {
                  window.__voxPendingSettingsTab = current.publish;
                  window.dispatchEvent(new CustomEvent('vox-open-settings', { detail: { tab: current.publish } }));
                } catch {}
                onOpenSettings();
              }}
              title={current.publishHint}
            >
              Publish a pack…
            </button>
          ) : null}
        </div>
        <nav className="vox-market-cats" aria-label="Marketplace categories">
          {CATEGORIES.map((c) => (
            <button key={c.key} type="button" className={`vox-sticker-nav-btn ${category === c.key ? 'active' : ''}`} aria-current={category === c.key ? 'page' : undefined} onClick={() => setCategory(c.key)}>
              <span aria-hidden="true">{c.icon}</span> {c.label}
            </button>
          ))}
        </nav>
        {category === 'stickers' ? <PackBrowser pageSize={24} /> : null}
        {category === 'sounds' ? <SoundPackBrowser pageSize={24} /> : null}
      </div>
    </div>
  );
}
